<template>
    <AutomationDesignerDashboard v-if="isReady" :automation="automation" @updateAutomation="updateAutomation" />
    <CbDashboardProgressBar v-else :isReady="isReady" text="Automation Loading" />
</template>

<script>
import AutomationDesignerDashboard from "./diagram/AutomationDesignerDashboard.vue";
import log2 from "../../../../../utils/log2";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import Vue from "vue";
import VAnimateCss from "v-animate-css";
import CbDashboardProgressBar from "../../../Chatbot/pages/dashboard/common/CbDashboardProgressBar.vue";
import { AUTOMATION_API } from "../../../../../api/automation";
import StringUtils from "../../../../../utils/StringUtils";
import { canViewAutomation } from "../../../../../utils/AutomationPermissionUtils";

Vue.use(VAnimateCss);
const log = log2("AutomationPlannerPage");

export default {
    name: "AutomationPlannerPage",
    components: {
        AutomationDesignerDashboard,
        CbDashboardProgressBar,
    },
    computed: {
        ...mapGetters({}),
        ...mapState({
            currentAutomation: (state) => state.automation.current,
            automations: (state) => state.automation.automations,
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        ...mapActions({
            getStory: "CB/getStory",
        }),
        ...mapMutations({
            setCurrentAutomation: "automation/setCurrentAutomation",
        }),
        updateAutomation(automation) {
            this.automation = automation;
        },
    },
    data() {
        return {
            automationId: window.location.pathname.split("/")[2],
            isReady: false,
            automation: {},
        };
    },

    beforeMount() {},
    async mounted() {
        log("mounted ", {
            automationId: this.automationId,
        });
        
        const startTS = Date.now();
        
        // Önce Vuex store'dan kontrol et
        const automationFromStore = this.automations.find((a) => a._id === this.automationId);
        
        if (automationFromStore) {
            // Store'da varsa direkt kullan
            // Önce yetki kontrolü yap
            if (!canViewAutomation(automationFromStore, this.user)) {
                this.$message.error(this.$t('automation.permissions.noReadAccess'));
                this.$router.push("/automations/all-automations");
                return;
            }
            
            this.automation = automationFromStore;
            this.isReady = true;
            log("Automation loaded from store");
            
            // Arka planda güncel versiyonu çek
            AUTOMATION_API.findAutomationById(this.automationId)
                .then((automation) => {
                    this.automation = automation;
                    this.setCurrentAutomation(automation);
                })
                .catch((error) => {
                    console.error("Error fetching automation in background:", error);
                });
        } else {
            // Store'da yoksa API'den çek
            try {
                const automation = await AUTOMATION_API.findAutomationById(this.automationId);
                
                // Yetki kontrolü yap
                if (!canViewAutomation(automation, this.user)) {
                    this.$message.error(this.$t('automation.permissions.noReadAccess'));
                    this.$router.push("/automations/all-automations");
                    return;
                }
                
                this.automation = automation;
                
                const tookTime = Date.now() - startTS;
                if (tookTime < 1000) {
                    setTimeout(() => {
                        this.isReady = true;
                    }, 1000 - tookTime);
                } else {
                    this.isReady = true;
                }
            } catch (error) {
                console.error("Error fetching automation:", error);
                this.$message.error("Otomasyon yüklenirken bir hata oluştu");
                this.isReady = true;
            }
        }
    },
    watch: {
        automation: {
            handler: function (automation) {
                const isEqual = StringUtils.hashCodeObj(automation) === StringUtils.hashCodeObj(this.currentAutomation);
                if (!isEqual) {
                    console.log("currentAutomation changed from inside");
                    this.setCurrentAutomation(automation);
                }
            },
            deep: true,
        },
        currentAutomation: {
            handler: function (automation) {
                const isEqual = StringUtils.hashCodeObj(automation) === StringUtils.hashCodeObj(this.automation);
                if (!isEqual) {
                    console.log("currentAutomation changed from outside");
                    this.automation = automation;
                }
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.ant-popover.no-padding {
    .ant-popover-inner-content {
        padding: 0 !important;
    }
}
</style>
